import './waterfall-tooltip.component.scss';
import { useMemo } from 'react';
import { formatNumber } from '../../../../../utils/formatting/number-formatter.helper';
import { DecompModelSparkLineComponent } from '../charts/decomp-model-spark-line.component';
import { WaterfallTooltipBar } from '../charts/waterfall-tooltip-bar.component';
import { WaterfallTooltipComponentProps } from './waterfall-tooltip.component';

const aspectRatio = 18 / 4;
export const WaterfallTooltipBodyComponent = ({
  data,
}: WaterfallTooltipComponentProps) => {
  const max = useMemo(() => {
    if (data && data.children) {
      const nums = data.children.map((i) => i.value);
      const max = nums.reduce((a, b) => Math.max(a, b), -9999999999999);
      return max;
    } else {
      return 0;
    }
  }, [data]);
  const min = useMemo(() => {
    if (data && data.children) {
      const nums = data.children.map((i) => i.value);
      const min = nums.reduce((a, b) => Math.min(a, b), 9999999999999);
      return min;
    } else {
      return 0;
    }
  }, [data]);
  const children = useMemo(() => {
    if (data && data?.children) {
      return data.children.sort((a, b) => a.value - b.value);
    } else {
      return [];
    }
  }, [data]);
  return (
    <div>
      <div className="waterfall-tooltip-body">
        <div className="container-fluid">
          <div className="row waterfall-tooltip-row waterfall-tooltip-header">
            <div className="col-3 waterfall-tooltip-header-label">
              Comp Brand
            </div>
            <div className="col-5 waterfall-tooltip-header-value">Impact</div>
            <div className="col-4 waterfall-tooltip-header-sparkline">
              Spark Line
            </div>
          </div>
          {children.map(
            (compBrand, index) =>
              compBrand.label !== '' && (
                <div className="row waterfall-tooltip-row" key={index}>
                  <div className="col-3 waterfall-tooltip-compbrand-label">
                    {compBrand.label}
                  </div>
                  <div className="col-2 waterfall-tooltip-compbrand-value">
                    {formatNumber(compBrand.value)}
                  </div>
                  <div className="col-3 waterfall-tooltip-compbrand-value">
                    <WaterfallTooltipBar
                      value={compBrand.value}
                      max={max}
                      min={min}
                      color={compBrand.color}
                    />
                  </div>
                  <div className="col-4 waterfall-tooltip-compbrand-sparkline">
                    <DecompModelSparkLineComponent
                      chartData={compBrand}
                      aspectRatio={aspectRatio}
                    />
                  </div>
                </div>
              ),
          )}
        </div>
      </div>
      <div className="waterfall-tooltip-footer">
        <div className="container-fluid">
          {data && (
            <div
              className="row waterfall-tooltip-row waterfall-tooltip-total"
              key={aspectRatio}
            >
              <div className="col-3 waterfall-tooltip-compbrand-label">
                Total
              </div>
              <div className="col-2 waterfall-tooltip-compbrand-value">
                {formatNumber(data?.value)}
              </div>
              <div className="col-3 waterfall-tooltip-compbrand-value" />
              <div className="col-4 waterfall-tooltip-compbrand-sparkline">
                <DecompModelSparkLineComponent
                  chartData={{
                    children: data.totals,
                    value: data.value,
                    id: data.id,
                    label: data.label,
                    color: data.color,
                    max: data.max,
                  }}
                  aspectRatio={aspectRatio}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
